import { css } from '@emotion/react';

import { LAYOUT2, TYPOGRAPHY2 } from '../Styles';

const COMMON_FORM_STYLE = css`
  label: COMMON_FORM_STYLE;
  display: flex;
  flex-direction: column;
  gap: ${LAYOUT2.spacing2}px;
  color: var(--text);
  ${TYPOGRAPHY2.small};
`;

export const StyledForm = ({ children, ...props }: { children: React.ReactNode } & React.HTMLAttributes<HTMLFormElement>) => {
  return <form css={COMMON_FORM_STYLE} {...props}>{children}</form>;
};
